import { graphql } from 'gatsby';
import Content, { HTMLContent } from '../components/Content';
import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout';
import { Helmet } from 'react-helmet';
import HeaderImage from '../components/HeaderImage';

export const TherapyPageTemplate = ({
  content,
  contentComponent,
  title,
  image,
  description,
  duration,
  price,
  helmet,
}) => {
  const PageContent = contentComponent || Content;

  return (
    <React.Fragment>
      <HeaderImage image={image} heading={title} />
      <section className="section">
        {helmet || ''}
        <div className="container content">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <h1 className="title is-size-2 has-text-weight-bold is-bold-light">
                {title}
              </h1>
              <p>{description}</p>
              <PageContent content={content} />
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

TherapyPageTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  title: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  description: PropTypes.string,
  duration: PropTypes.number,
  price: PropTypes.number,
  helmet: PropTypes.object,
};

const TherapyPage = ({ data }) => {
  const { markdownRemark: page } = data;

  return (
    <Layout>
      <TherapyPageTemplate
        {...page.frontmatter}
        content={page.html}
        contentComponent={HTMLContent}
        helmet={
          <Helmet titleTemplate="%s">
            <title>{`${page.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${page.frontmatter.description}`}
            />
          </Helmet>
        }
      />
    </Layout>
  );
};

TherapyPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default TherapyPage;

export const pageQuery = graphql`
  query TherapyPageByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        description
        duration
        price
      }
    }
  }
`;
